import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule, PodNgCoreModule } from 'pod-ng-core';
import { UsageParamsComponent } from './usage-params.component';

@NgModule({
  declarations: [UsageParamsComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    PodNgCoreModule.forChild(),
    PipesModule,
  ],
  exports: [UsageParamsComponent],
})
export class UsageParamsModule {}
